
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import DocumentUpload from '@/components/application/DocumentUpload';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const DocumentsPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />
        
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Document Verification
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Please provide the required documents to verify your eligibility
        </p>
        
        <div className="max-w-2xl mx-auto">
          <DocumentUpload />
        </div>
      </div>
    </AppLayout>
  );
};

export default DocumentsPage;
